import React from 'react';
import axios from '../../config/axiosInstance';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import RegisterActivity from './RegisterActivity';
import ViewActivities from './ViewActivities';
import FinishActivity from './FinishActivity';
import { Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText } from '@material-ui/core';

const styles = theme => ({
    button: {
        borderRadius: '20px',
        color: '#FFF',
        fontWeight: 'bold',
        backgroundColor: '#537ccd',
        '&:hover': {
            color: '#537CCD',
            backgroundColor: '#FFF',
        },
    },
    buttonTitle: {
        margin: '2px',
    }
});

export class WorkActivity extends React.Component {
    state = {
        showTable: 0,
        openModal: false,
        info: 'funciona',
        allActivities: [],
    }

    componentDidMount() {
        this.renderActivity();
    }

    renderActivity = () => { //essa função via ir para o aquivo principal
        axios.get('workActivity/allActivities', { headers: { Authorization: ` Bearer ${localStorage.token}` } })
            .then((response) => {
                this.setState({
                    allActivities: response.data.slice(0, -1).filter(i => i.employee.name == localStorage.socialName).reverse(),
                });
            })
            .catch(error => console.log('error', error));
    };

    openModal = () => {
        this.setState({ openModal: true });
    };

    closeModal = () => {
        this.setState({ openModal: false });
    };

    changeShowTable = (status) => {
        if (status == 1) {
            this.setState({ showTable: status });
        } else if (status == 2) {
            this.setState({ showTable: status });
        } else {
            this.setState({ showTable: status });
        }
    };

    render() {
        const { classes } = this.props;

        return (
            <Paper variant="outlined" size="medium" color="inherit"
                className={classes.button}>
                <Button
                    variant="outlined" size="medium" color="inherit"
                    className={classes.button}
                    onClick={this.openModal}>
                    Central de Os
                </Button>
                <Dialog
                    open={this.state.openModal}
                    onClose={this.closeModal}
                    aria-labelledby="title"
                    aria-describedby="description"
                >
                    <DialogTitle id="title" style={{ textAlign: 'center' }}>
                        Central de Os
                        <DialogContentText id="description" style={{ padding: 2 }}>
                            <Button className={classes.buttonTitle} style={this.state.showTable == 0 ? { backgroundColor: '#D5D7E0' } : {}} variant="outlined" onClick={status => this.changeShowTable(0)}>Iniciar Atividade</Button>
                            <Button className={classes.buttonTitle} style={this.state.showTable == 1 ? { backgroundColor: '#D5D7E0' } : {}} variant="outlined" onClick={status => this.changeShowTable(1)}>Visualizar Atividade</Button>
                            <Button className={classes.buttonTitle} style={this.state.showTable == 2 ? { backgroundColor: '#D5D7E0' } : {}} variant="outlined" onClick={status => this.changeShowTable(2)}>Finalizar Atividade</Button>
                        </DialogContentText>
                    </DialogTitle>
                    <DialogContent>
                        {this.state.showTable == 0 ?
                            (<RegisterActivity
                                allActivities={this.state.allActivities}
                                close={this.closeModal}
                            />)
                            : this.state.showTable == 1 ?
                                <ViewActivities
                                    allActivities={this.state.allActivities}
                                />
                                : this.state.showTable == 2 ?
                                    <FinishActivity
                                        allActivities={this.state.allActivities}
                                        close={this.closeModal}
                                    /> : <></>}
                    </DialogContent>
                </Dialog>
            </Paper >
        );
    }
}

export default withStyles(styles)(WorkActivity);
